<template>
  <div class="main-container" v-bind:class="{'simple__view': (nfcAvailable && !displayForm)}">
    <div class="container__alert">
        <!-- alert--error | alert--information -->
      <transition name="alert--animation">
        <div class="alert alert--error alert__errorConnexion" v-if="!compatibility || wrongAuth || accessExpired">
            <div class="alert__header">
                <div class="alert__title">
                    <p>{{translationArray.error_connection}}</p>
                </div>
                <hr>
            </div>

            <div class="alert__body">
                <div class="alert__image">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0.340562 19.6125C-0.425702 18.9151 0.340562 17.8689 0.340562 17.8689L8.3095 9.88624L0.512983 2.00191C0.512983 2.00191 -0.360283 0.994184 0.512983 0.258302C1.20265 -0.322869 2.06476 0.258287 2.06476 0.258287L9.99612 8.19672L17.7551 0.43265C17.7551 0.43265 18.7896 -0.43915 19.6517 0.43265C20.3414 1.13006 19.6517 2.00191 19.6517 2.00191L11.6341 9.76105L19.6517 17.8689C19.6517 17.8689 20.4354 18.7407 19.6517 19.6125C18.868 20.4843 17.7551 19.6125 17.7551 19.6125L9.8237 11.5919L1.89235 19.6125C1.89235 19.6125 1.10683 20.31 0.340562 19.6125Z" fill="white" fill-opacity="0.9"/>
                        </svg>
                </div>
                <div class="alert__description">
                    <p v-if="!compatibility">{{translationArray.object_not_allowed}}<a href="#">help.senzu.app/login</a></p>
                    <p v-if="wrongAuth">{{translationArray.wront_auth}}</p>
                    <p v-if="accessExpired">{{translationArray.session_expired_desktop}}</p>
                </div>
            </div>
        </div>
      </transition>

      <div class="alert alert--information alert__askNFC" v-if="modalNFCLocked">
          <div class="alert__header">
              <div class="alert__title">
                  <p>{{translationArray.use_nfc}}</p>
              </div>
              <hr>
          </div>

          <div class="alert__body">
              <div class="alert__image">
                  <svg width="40" height="50" viewBox="0 0 40 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.26095 15.2173C1.45656 15.2173 0 16.8195 0 18.8043V35.5439C0 37.5287 1.45656 39.1309 3.26095 39.1309C5.06534 39.1309 6.52189 37.5287 6.52189 35.5439V18.8043C6.52189 16.8195 5.06534 15.2173 3.26095 15.2173Z" fill="white"/>
                      <path d="M14.1311 39.1304C12.3267 39.1304 10.8701 39.8586 10.8701 40.7608V48.3697C10.8701 49.2719 12.3267 50.0002 14.1311 50.0002C15.9355 50.0002 17.392 49.2719 17.392 48.3697V40.7608C17.392 39.8586 15.9355 39.1304 14.1311 39.1304Z" fill="white"/>
                      <path d="M25.0007 39.1304C23.1963 39.1304 21.7397 39.8586 21.7397 40.7608V48.3697C21.7397 49.2719 23.1963 50.0002 25.0007 50.0002C26.8051 50.0002 28.2616 49.2719 28.2616 48.3697V40.7608C28.2616 39.8586 26.8051 39.1304 25.0007 39.1304Z" fill="white"/>
                      <path d="M35.8703 15.2173C34.0659 15.2173 32.6094 16.8195 32.6094 18.8043V35.5439C32.6094 37.5287 34.0659 39.1309 35.8703 39.1309C37.6747 39.1309 39.1313 37.5287 39.1313 35.5439V18.8043C39.1313 16.8195 37.6747 15.2173 35.8703 15.2173Z" fill="white"/>
                      <path d="M9.97995 22.4673L13.6494 29.4267L13.6494 29.4268C14.7837 31.577 16.9887 33.0423 19.443 33.1354L17.3943 37.006C12.5309 36.0469 8.90674 31.8993 8.90674 26.9634C8.90674 25.3536 9.29295 23.826 9.97995 22.4673ZM19.5342 15.9519L19.5342 15.9521L19.5342 15.9519ZM28.3842 21.1783L20.3546 20.771C20.3538 20.771 20.3531 20.7709 20.3523 20.7709C17.8671 20.6314 15.4263 21.7453 14.1154 23.7708L11.6395 20.102C13.6723 17.9181 16.5694 16.7137 19.5371 16.7019L19.5393 16.7019C21.3607 16.6895 23.2216 17.1379 24.9149 18.0809C26.3471 18.8831 27.5128 19.9507 28.3842 21.1783ZM24.914 35.8419C23.4727 36.649 21.914 37.0864 20.3535 37.1958L24.7187 30.722C26.0871 28.6951 26.3097 26.1132 25.1788 24.0046L29.7146 23.7792C31.2528 28.273 29.3729 33.3597 24.9156 35.841L24.914 35.8419ZM19.5756 29.9254C17.8367 29.9254 16.4763 28.5751 16.4763 26.9634C16.4763 25.3479 17.8361 24.0015 19.5756 24.0015C21.3145 24.0015 22.6749 25.3517 22.6749 26.9634C22.6749 28.5751 21.3145 29.9254 19.5756 29.9254Z" stroke="white" stroke-width="1.5"/>
                      <path d="M26.3249 4.10406L28.7919 1.63402C29.1715 1.25402 29.1715 0.665009 28.7919 0.285004C28.4124 -0.0950013 27.8241 -0.0950013 27.4446 0.285004L24.636 3.09704C23.1368 2.33703 21.4288 1.90003 19.626 1.90003C17.8042 1.90003 16.0963 2.33703 14.5781 3.09704L11.7505 0.285004C11.371 -0.0950013 10.7827 -0.0950013 10.4031 0.285004C10.0236 0.665009 10.0236 1.25402 10.4031 1.63402L12.8891 4.12306C10.0805 6.19409 8.23975 9.51913 8.23975 13.3002H31.0123C31.0123 9.51913 29.1715 6.17509 26.3249 4.10406Z" fill="white"/>
                      <path d="M16.4152 9.08272H14.5986V7.26611H16.4152V9.08272Z" fill="#DADADA"/>
                      <path d="M25.4973 9.08272H23.7456V7.26611H25.4973V9.08272Z" fill="#DADADA"/>
                      </svg>
              </div>
              <div class="alert__description">
                  <p>{{translationArray.use_browser_0}}<span class="bold">Android</span>{{translationArray.use_browser_1}}<span class="bold">Chrome</span>{{translationArray.use_browser_2}}</p>
              </div>
          </div>
      </div>

      <div class="alert alert__connexion tag__connection" v-if="loadingConnection">
          <div class="alert__header">
              <div class="alert__title">
                  <p>{{translationArray.connecting}}</p>
                  <div class="loading">
                      <div class="animateSpin">
                          <div class="loader">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>

    </div>

    <div class="container__modal" v-if="modalNFC">
        <div class="modal modal__askNFC" v-if="modalNFC">
            <div class="modal__content">
                    <p class="modal__title">{{translationArray.grant_nfc}}</p>
                    <div class="modal__image">
                        <img src="../../static/img/phone_scanning.png" alt="demonstration of scanning NFC object">
                    </div>
                    <p class="modal__description">{{translationArray.grant_nfc_browser}}</p>
                    <div class="modal__btn">
                        <button class="modal__btn__cancel btn btn__red" @click="updateModalNFC()">{{translationArray.deny}}</button>
                        <button class="modal__btn__confirm btn btn__green" @click="updateModalNFC(true)">{{translationArray.allow}}</button>
                    </div>
                </div>
        </div>
    </div>
    <header>
        <svg class="waves" width="455" height="455" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="227.949" cy="227.949" r="124.244" stroke="#3CB5A8"/>
          <circle cx="227.949" cy="227.948" r="173.603" stroke="#3CB5A8" stroke-opacity="0.4"/>
          <circle cx="227.5" cy="227.5" r="227" stroke="#3CB5A8" stroke-opacity="0.1"/>
        </svg>

        <!--<svg class="waves" width="455" height="455" viewBox="0 0 455 455" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="227" cy="228" r="78.5" stroke="#3CB5A8" stroke-opacity="0.47" stroke-width="3"/>
            <circle cx="227.5" cy="227.5" r="141.25" stroke="#3CB5A8" stroke-opacity="0.38" stroke-width="2.5"/>
            <circle cx="227.5" cy="227.5" r="226.5" stroke="#3CB5A8" stroke-opacity="0.29" stroke-width="2"/>
        </svg>-->

        <div class="containerTitle">
            <h1>{{translationArray.connection}}</h1>
            <p>{{translationArray.on}}<span>{{nameClient}}</span></p>
        </div>

        <div class="containerPartner">
            <div class="partnerBox partnerBox__Left" v-if="!isSenzuApp">
              <img v-if="!hasImageClient" src="../../static/img/logo.png" :alt="'image_' + nameClient">
              <img v-if="hasImageClient" :src="urlImageClient" :alt="'image_' + nameClient">
            </div>
            <div class="partnerSeparation" v-if="!isSenzuApp">
                <svg width="34" height="54" viewBox="0 0 34 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M33.0607 13.0607C33.6464 12.4749 33.6464 11.5251 33.0607 10.9393L23.5147 1.3934C22.9289 0.807611 21.9792 0.807611 21.3934 1.3934C20.8076 1.97919 20.8076 2.92893 21.3934 3.51472L29.8787 12L21.3934 20.4853C20.8076 21.0711 20.8076 22.0208 21.3934 22.6066C21.9792 23.1924 22.9289 23.1924 23.5147 22.6066L33.0607 13.0607ZM1 13.5H32V10.5H1V13.5Z" fill="#EEEEEE"/>
                    <path d="M0.939339 40.9393C0.353554 41.5251 0.353554 42.4749 0.939339 43.0607L10.4853 52.6066C11.0711 53.1924 12.0208 53.1924 12.6066 52.6066C13.1924 52.0208 13.1924 51.0711 12.6066 50.4853L4.12132 42L12.6066 33.5147C13.1924 32.9289 13.1924 31.9792 12.6066 31.3934C12.0208 30.8076 11.0711 30.8076 10.4853 31.3934L0.939339 40.9393ZM33 40.5H2V43.5H33V40.5Z" fill="#EEEEEE"/>
                </svg>
            </div>
            <div class=" partnerBox partnerBox__Right">
                <img src="../../static/img/senzu.png" alt="">
            </div>
            <p v-if="!displayForm">{{translationArray.object_behind_device}}</p>
        </div>
        <div class="containerDescription">
            <div class="containerDescriptionBox" v-if="!isNfcOk">
                <div class="information__askNFC">
                    <p>{{translationArray.nfc_connection}}</p>
                </div>
                <div class="btn__askNFC" @click="updateModalNFC()" v-bind:class="{'btn__askNFC--blocked': !nfcAvailable}">
                    <p>{{translationArray.unlock}}</p>
                    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 4C7.5 3.44439 8 3 8.5 3C9 3 9.5 3.42795 9.5 4C9.5 4.57205 9 5 8.5 5C8 5 7.5 4.55561 7.5 4Z" fill="#F3F3F3"/>
                        <path d="M7.58887 13.0535C7.58916 12.7499 7.59005 6.30357 7.58946 6C7.58887 5.69643 8.16468 6 8.5 6C8.83532 6 9.41059 5.69643 9.41089 6C9.41118 6.30357 9.41118 12.7499 9.41089 13.0535C9.41059 13.3571 10.0177 13.6606 9.71446 13.6606H8.19601C7.89214 13.6606 7.58857 13.3571 7.58887 13.0535Z" fill="#F3F3F3"/>
                        <circle cx="8.5" cy="8.5" r="8" stroke="#F1F1F1"/>
                        </svg>
                </div>
            </div>

            <p class="information__title__mobile" v-if="isNfcOk && displayForm">{{translationArray.object_behind_device}}</p>
            <p class="information__mobile" v-if="isMobile">
              <span v-if="!nfcAvailable">{{translationArray.no_nfc}}</span>
              <span class="link" @click="QrCode()">
                    {{translationArray.use_qr}}
                <svg class="qrcode" width="15" height="15" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.625 3.5625H14.8438L14.25 2.375C13.9003 1.68386 13.7186 1.1875 13.0625 1.1875H5.9375C5.28141 1.1875 5.06468 1.75393 4.75 2.375L4.15625 3.5625H2.375C1.06341 3.5625 0 4.62591 0 5.9375V15.4375C0 16.7491 1.06341 17.8125 2.375 17.8125H16.625C17.9366 17.8125 19 16.7491 19 15.4375V5.9375C19 4.62591 17.9366 3.5625 16.625 3.5625ZM17.8125 15.4375C17.8125 16.0936 17.2811 16.625 16.625 16.625H2.375C1.71891 16.625 1.1875 16.0936 1.1875 15.4375V5.9375C1.1875 5.282 1.71891 4.75 2.375 4.75H4.75L5.34375 3.5625C5.76352 2.87198 5.87516 2.375 6.53125 2.375H12.4688C13.1248 2.375 13.2365 2.87136 13.6562 3.5625L14.25 4.75H16.625C17.2811 4.75 17.8125 5.28141 17.8125 5.9375V15.4375ZM9.5 5.9375C6.87682 5.9375 4.75 8.06432 4.75 10.6875C4.75 13.3107 6.87682 15.4375 9.5 15.4375C12.1232 15.4375 14.25 13.3107 14.25 10.6875C14.25 8.06432 12.1232 5.9375 9.5 5.9375ZM9.5 14.25C7.53232 14.25 5.9375 12.6552 5.9375 10.6875C5.9375 8.71982 7.53232 7.125 9.5 7.125C11.4677 7.125 13.0625 8.71982 13.0625 10.6875C13.0625 12.6552 11.4677 14.25 9.5 14.25Z" fill="#3CB5A8"/>
                </svg>
              </span>
            </p>
            <p class="information__mobile link" @click="displayFormFnc()" v-if="nfcAvailable && !displayForm">{{translationArray.use_form}}</p>
        </div>
    </header>

    <section class="body" v-if="displayForm">

        <p class="body__separator">{{translationArray.or}}</p>
        <form id="login" @submit="checkLogin" method="POST">
            <p class="form__title" >{{translationArray.with_email_phone}}</p>
            <fieldset class="formRow">
                <legend>{{translationArray.email_phone}}</legend>
                <input type="text" id="email" name="email" v-model="email">
            </fieldset>
            <fieldset class="formRow">
                <legend>{{translationArray.password}}</legend>
                <input type="password" id="password" name="password" v-model="password">
            </fieldset>
            <div class="formRow">
                <input class="submit" type="submit" value="Se connecter">
            </div>
            <input type="hidden" name="senzu_token" :value="csrfToken">
        </form>
    </section>
    <footer v-if="displayForm">
        <a @click="redirectPassword()" class='link forgetPassword' v-if="isMobile">{{translationArray.forget_password}}</a>
    </footer>
  </div>
</template>

<script>
    import {translate} from '../../static/js/translate';

    export default {
        name: 'QrCodeRedirect',
        data() {
            return {
                data: {},
                isNfcOk: false,
                isSenzuApp: false,
                chromeBrowser: false,
                androidDevice: false,
                compatibility: true,
                nameClient: null,
                urlImageClient: null,
                hasImageClient: false,
                displayForm: true,
                email: null,
                password: null,
                wrongAuth: false,
                clientId: 1,
                modalNFC: false,
                modalNFCLocked: false,
                nfcLocked: false,
                compatibilityDisplay: false,
                compatibilityHide: false,
                loadingConnection: false,
                isMobile: true,
                callOnGoing: false,
                accessExpired: false,
                timestampPageOpen: null,
                translationArray: {},
                idRecord: null,
                keyRecord: null,
                csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            }
        },
        computed: {
            nfcAvailable: function() {
                if(this.chromeBrowser && this.androidDevice) {
                    return true;
                } else {
                    return false;
                }
            },
            errorModal: function() {
                if(!this.compatibility || this.wrongAuth) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        watch: {
            wrongAuth: function(value) {
                let _this = this;
                var interval = setInterval(function() {
                _this.wrongAuth = false;
                clearInterval(interval);
                }, 5400);
            },
            compatibility: function(value) {
                let _this = this;
                //Redirection vers Wallet
                this.$router.replace({name: 'Wallet', query: {
                    id_record: this.idRecord,
                    key_record: this.keyRecord,
                    key: this.$route.query.key,
                    client_id: this.$route.query.client_id,
                    }
                });
                var interval = setInterval(function() {
                    _this.compatibility = true;
                    clearInterval(interval);
                }, 5400);
            },
            modalNFCLocked: function(value) {
                let _this = this;
                var interval = setInterval(function() {
                    _this.modalNFCLocked = false;
                    clearInterval(interval);
                }, 5400);
            },
            accessExpired: function(value) {
                let _this = this;
                var interval = setInterval(function() {
                    _this.accessExpired = false;
                    clearInterval(interval);
                }, 5400);
            },
        },
        mounted() {
            this.translationArray = translate(navigator.language.substr(0, 2));

            this.timestampPageOpen = Math.round(Date.now() / 1000);

            if (navigator.userAgent.indexOf("Chrome") !== -1) {
                this.chromeBrowser = true;
            }
            if(navigator.userAgent.toLowerCase().indexOf("android") !== -1) {
                this.androidDevice = true;
            }

            let clientId = typeof(this.$route.query.client_id) !== "undefined" ? this.$route.query.client_id : null;
            if(clientId <= 8 || typeof(clientId) == 'undefined') {
                this.isSenzuApp = true;
            }

            fetch(`${this.$origin}/client/${clientId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'CSRF-Token': this.csrfToken
                },
            }).then(result => result.json())
                .then(data => {
                    if(data.url_image != null) {
                        this.hasImageClient = true;
                        this.urlImageClient = data.url_image;
                    }

                    this.nameClient = data.display_name;

                    localStorage.setItem("name_client", this.nameClient);
                    localStorage.setItem("has_image_client", this.hasImageClient);
                    localStorage.setItem("url_image_client", this.urlImageClient);

                    this.$senzuAuth.nameClient = data.display_name;
                    this.$senzuAuth.hasImageClient = this.hasImageClient;
                    this.$senzuAuth.urlImageClient = this.urlImageClient;
                }
            );

            async function nfcPermission() {
                return await navigator.permissions.query({name: "nfc"});
            }

            let permission = (async() => {
                let result = await nfcPermission();
                if(result.state === "granted") {
                    this.isNfcOk = true;
                    this.displayForm = false;
                    this.nfc();
                    $('.waves').css('animation-name', 'growWaves');
                }
            })();
        },
        methods: {
            redirectPassword: function() {
                this.$router.replace({name: 'ResetPassword'});
            },
            displayFormFnc: function() {
                this.displayForm = true;
            },
            QrCode: function() {
                this.$router.replace({name: 'QrCode', query: {
                    client_id: this.$route.query.client_id,
                    redirect_uri: this.$route.query.redirect_uri,
                    response_type: this.$route.query.response_type,
                    scope: this.$route.query.scope,
                    code_challenge: this.$route.query.code_challenge,
                    code_challenge_method: this.$route.query.code_challenge_method,
                    state: this.$route.query.state,
                }});
            },
            updateModalNFC: function(activated) {
                if(this.nfcAvailable) {
                    if(this.modalNFC) {
                        if(activated) {
                            async function nfcPermission() {
                            return await navigator.permissions.query({name: "nfc"});
                            }

                            let permission = (async() => {
                            let result = await nfcPermission();
                            if(result.state === "prompt") {
                                this.nfc();
                            }
                            })();
                        }
                        this.modalNFC = false;
                    } else {
                    this.modalNFC = true;
                    }
                } else {
                    this.modalNFCLocked = true;
                }
            },
            checkLogin: async function(e) {
                e.preventDefault();

                const data = {email: this.email, password: this.password};

                var countryCode = "US";
                await fetch("https://api.senzu.app/ip", {
                method: 'GET'
                }).then(result => result.json())
                .then(data => {
                    countryCode = data.country;
                }
                );

                fetch(`${this.$origin}/authorize/qr?key=${encodeURIComponent(this.$route.query.key)}&timestamp=${this.timestampPageOpen}&country_code=${countryCode}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'CSRF-Token': this.csrfToken
                    },
                    body: JSON.stringify(data)
                }).then(result => result.json())
                .then(data => {

                    if(data.error === 200) {
                        this.$router.replace({name: 'Success'});
                    } else if(data.error === 400) {
                        this.wrongAuth = true;
                    } else if(data.error === 463) {
                        this.$router.replace({name: 'Error', query: {params: 'expired'}});
                    } else {
                        this.$router.replace({name: 'Error', query: {params: 'conflict'}});
                    }
                });
            },
            nfc: function() {
                try {
                    const reader = new NDEFReader();
                    let abortController = new AbortController();
                    reader.scan({signal: abortController.signal});

                    async function nfcPermission() {
                        return await navigator.permissions.query({name: "nfc"});
                    }

                    let permission = (async() => {
                        let result = await nfcPermission();
                        let _this = this;

                        result.onchange = function(event) {
                            if(event.target.state === "granted") {
                                $('.waves').css('animation-name', 'growWaves');
                                _this.isNfcOk = true;
                                _this.displayForm = false;
                            }
                        }
                    })();

                    reader.addEventListener("error", (event) => {
                        console.log(`Argh! ${event.message}`);
                    });

                    reader.addEventListener("reading", ({ message, serialNumber }) => {
                        const textDecoder = new TextDecoder();
                        var url = textDecoder.decode(message.records[0].data);
                        let dataUrl = url.match(/[0-9]*@[a-zA-Z0-9]*/);

                        this.compatibility = true;

                        dataUrl = dataUrl[0].split("@");
                        this.idRecord = dataUrl[0];
                        this.keyRecord = dataUrl[1];

                        if(dataUrl != null) {
                            if(!this.callOnGoing) {
                                this.callOnGoing = true;
                                fetch(`${this.$origin}/record-allowed?id_record=${dataUrl[0]}&key=${dataUrl[1]}&client_id=${this.$route.query.client_id}`, {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'CSRF-Token': this.csrfToken
                                    },
                                }).then(result => result.json())
                                    .then(data => {
                                        if(data.error == 200) {
                                            fetch(`${this.$origin}/check-qr?id_record=${dataUrl[0]}&key_record=${dataUrl[1]}&key=${encodeURIComponent(this.$route.query.key)}&timestamp=${this.timestampPageOpen}`, {
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'CSRF-Token': this.csrfToken
                                                }
                                            }).then(result => result.json())
                                            .then(data => {
                                                if(data.error == 200) {
                                                    this.callOnGoing = false;   
                                                    this.$router.replace({name: 'Success', query: {params: 1}});
                                                } else if(data.error == 463) {
                                                    this.callOnGoing = false;                          
                                                    this.$router.replace({name: 'Error', query: {params: 'expired'}});
                                                } else {
                                                    this.callOnGoing = false;
                                                    this.$router.replace({name: 'Error', query: {params: 'conflict'}});
                                                }                                                
                                            });
                                        } else {
                                            this.callOnGoing = false;
                                            this.compatibility = false;
                                        }
                                    }
                                );
                            }
                        } else {
                            if(data.status === -1) {
                                localStorage.setItem("reference", data.reference); 
                                localStorage.setItem("wallet_status", data.status);                   
                            } else {
                                localStorage.setItem("wallet_status", data.status);
                            }                                  
                            this.callOnGoing = false;
                            this.compatibility = false;
                        }
                    });
                } catch(e) {

                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/QrCodeRedirect.vue